import { connect } from 'react-redux'
import CourseHeader from './component'

import NavigationHelper from 'layers/navigation/navigationHelper'

export default connect(null, NavigationHelper.mapDispatchToProps)(CourseHeader)
